<template>
  <RevCoupon
    v-if="dealTag"
    :icon="dealTag.icon"
    :label="dealTag.label"
    :tone="dealTag.tone"
    :tooltip-text="dealTag.tooltipText"
  />
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import { RevCoupon } from '@ds/components/Coupon'

defineProps<{
  dealTag?: {
    label: string
    icon: Component
    tooltipText?: string
    tone?: 'success' | 'neutral'
  }
}>()
</script>
